import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProjectionInstance } from './projector.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectionService {
  instances$ = new BehaviorSubject<ProjectionInstance>(null);

  activate(target: string, template: TemplateRef<unknown>): void {
    let value = this.instances$.getValue();

    value ? (value[target] = template) : (value = { [target]: template });
    this.instances$.next(value);
  }

  clear(target: string): void {
    const value = this.instances$.getValue();

    if (value) {
      value[target] = null;
    }
    this.instances$.next(value);
  }

  clearAll(): void {
    this.instances$.next(null);
  }
}
